export const messages = {
  title: "メッセージ",
  edit: "編集",
  tabAll: "全員",
  tabActive: "会話中",
  tabBookmark: "お気に入り",
} as const;
